import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import i18n from 'modules/core/lib/i18n'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { useBulkDestroyUploadProcessDocuments } from 'modules/documents/hooks/useBulkDestroyUploadProcessDocuments'

interface Props {
  document: Document
  onClose: () => void
  onDelete: (documentIds: string[]) => void
}

const DeleteOneDocumentModal = ({ document, onClose, onDelete }: Props) => {
  const { bulkDestroyUploadProcessDocuments, loading } = useBulkDestroyUploadProcessDocuments()

  const bulkDestroy = async (closePortal: ClosePortalFn) => {
    const documentIds = [document.id]
    await bulkDestroyUploadProcessDocuments({ documentIds })
    onDelete(documentIds)
    closePortal()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('documents.delete_all.confirm.title')}
      description={i18n.t('documents.delete_one.confirm.description', {
        name: document.filename,
      })}
      onClose={onClose}
      onSubmit={(closePortal: ClosePortalFn) => bulkDestroy(closePortal)}
      footer={
        <Button type="negative" disabled={loading} submit>
          {i18n.t('documents.delete_one.button_label')}
        </Button>
      }
    />
  )
}

export default DeleteOneDocumentModal
